import React, { createContext, useReducer, useContext } from 'react';
import { TokenContext } from 'contexts/Tokens/TokenContext';
import {
  setMode,
  setPoint,
  setPolygon,
  setFeature,
  setDrawModeFD,
  setTile,
  setFieldId,
  setLocation,
  setDataLayerFD,
  setAPIFD,
  setToken,
  setTiles,
  setTileURL,
  setDRResult,
  setFDResult,
  setMGRSTileExceptionPolygon,
  setOrderName,
  setAllDataInfo,
} from 'contexts/Map/action';

const initialState = {
  mode: '',
  point: undefined,
  polygon: undefined,
  token: 'a0731a8c-5259-4c68-af3a-7ad4f6d53faa',
  tileUrlCounter: 0,
  dataLayerFD: {
    type: 'delineatedFields',
    api: 'point',
    drawMode: 'draw_single_point',
  },
  drResult: undefined,
  renderOption: 'rgbn_rgb',
  orderName: '',
  allDataInfo: {},
};

const FDContext = createContext(initialState);
const { Provider } = FDContext;

const fdReducer = (state, action) => {
  switch (action.type) {
    case setMode:
      return {
        ...state,
        mode: action.payload.mode,
        drawMode: action.payload.drawMode,
      };
    case setPoint:
      return { ...state, point: action.payload.point, feature: undefined };
    case setPolygon:
      return { ...state, polygon: action.payload.polygon, feature: undefined };
    case setFeature:
      return { ...state, feature: action.payload.feature };
    case setTile:
      return { ...state, tile: action.payload.tile };
    case setFieldId:
      return { ...state, fieldId: action.payload.fieldId };
    case setLocation:
      return { ...state, location: action.payload.location };
    case setDataLayerFD:
      return {
        ...state,
        feature: undefined,
        dataLayerFD: action.payload.dataLayerFD,
        location: action.payload.location
          ? action.payload.location
          : state.location,
      };
    case setAPIFD:
      return {
        token: state.token,
        dataLayerFD: {
          ...state.dataLayerFD,
          api: action.payload.api,
          drawMode: action.payload.drawMode ? action.payload.drawMode : '',
        },
      };
    case setToken:
      return { ...state, token: action.payload.token };
    case setTiles:
      return { ...state, tiles: action.payload.tiles };
    case setTileURL:
      return {
        ...state,
        tileUrlCounter: Math.random(),
        tileURL: action.payload.tileURL,
        tileBounds: action.payload.tileBounds,
        viewBounds: action.payload.viewBounds,
        tileId: action.payload.tileId,
      };
    case setDrawModeFD:
      return {
        ...state,
        dataLayerFD: {
          ...state.dataLayerFD,
          drawMode: action.payload.drawMode,
        },
      };
    case setDRResult:
      return {
        ...state,
        drResult: action.payload.drResult,
        renderOption: action.payload.renderOption,
      };
    case setFDResult:
      return {
        ...state,
        drResult: action.payload.fdResult,
      };
    case setMGRSTileExceptionPolygon:
      return { ...state, mgrsExceptionPolygon: action.payload.polygon };
    case setOrderName:
      return {
        ...state,
        orderName: action.payload.orderName,
      };
    case setAllDataInfo:
      return {
        ...state,
        allDataInfo: {
          ...state.allDataInfo,
          ...action.payload.data, // Merge new data with existing accumulated data
        },
      };
    default:
      throw new Error();
  }
};

const FDProvider = (props) => {
  const { tokens, setTokens } = useContext(TokenContext);
  const initialStateWithToken = { ...initialState, token: tokens }; // Update initialState with tokens
  const [state, dispatch] = useReducer(fdReducer, initialStateWithToken);

  return <Provider value={{ state, dispatch }} {...props} />;
};

export { FDContext, FDProvider };
